import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';

import CourseDetail from '../components/Education/CourseDetail';
import courseQuery from '../lib/queries/courses/courseQuery.graphql';
import withApollo from '../lib/apollo';

const Course = ({ router }) => {
  const { id } = router.query;
  const courseId = Number(id);

  return (
    <CourseDetail
      query={courseQuery}
      variables={{ id: courseId }}
      errorMessage="Error loading this course info"
    />
  );
};

Course.propTypes = {
  router: PropTypes.shape({
    query: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

Course.defaultProps = {
  router: {},
};

export default withApollo(withRouter(Course));
